export default {
  state: {
    messageList: []
  },
  mutations: {
    setMessageList(state, message) {
      state.messageList.splice(0, 0, message);
    },
    removeMessage(state, data) {
      state.messageList.splice(data.index, 1);
    },
    setPostData(state, data) {
      state.postData = data;
    }
  },
  getters: {
    message: state => {
      return state.messageList;
    },
    postData: state => {
      return state.postData;
    }
  },
  actions: {
    addMessage({ commit }, { message }) {
      commit("setMessageList", { title: message });
    },
    removeMessage({ commit }, { index }) {
      commit("removeMessage", { index });
    }
  }
};
